import { useSelector } from 'react-redux';
import { RootState } from 'src/actions/configuration/rootReducer';

const useRoleFeatures = () => useSelector((state: RootState) => state.roleFeatures);
export default useRoleFeatures;
